import {RequestFactory} from "@/requests/RequestFactory";
const indicadorRequest = RequestFactory.get("indicador");


export default {
  namespaced: true,

  state: {
    isFetching: false,
    items: {},
    resumeByParent: {}
  },

  mutations: {
    FETCHING_OFF(state) {
      state.isFetching = false;
    },
    FETCHING_ON(state) {
      state.isFetching = true;
    }    
  },

  actions: {
    requestOn({commit}) { commit('FETCHING_ON'); },
    requestOff({commit}) { commit('FETCHING_OFF'); },

    fetchIndicador: ({dispatch}, {indicadorId}) => dispatch('fetchItem', {
      resource: 'indicador',
      indicadorId
    }, {root: true}),

    fetchIndicadores: ({dispatch}, logicaIntervencaoId) => {
      const payload = {resource: 'indicador', id: logicaIntervencaoId}
      dispatch('fetchItemsParent', payload, {root: true})
    },

    criarIndicador ({commit, dispatch}, payload) {
      dispatch('requestOn');
      return indicadorRequest.post(payload.id, payload.indicador).then(response => {
        dispatch('requestOff');
        const payload = {resource: 'indicador', item: response.data}
        commit('setItem', payload, {root: true})

        const notification = {
          type: 'success',
          message: 'Indicador criado com sucesso'
        }        
        dispatch('notification/add', notification, {root: true})
        
        return response.data
      }).catch(error => {
        const notification = {
          type: 'error',
          message: 'Ocorreu um erro inesperado. Por favor, tente novamente.'
        }
        
        dispatch('notification/add', notification, {root: true})

        return error

      });
    },

    deleteIndicador({commit, dispatch}, indicadorId) {
      dispatch('requestOn');      
      return indicadorRequest.delete(indicadorId).then( () => {
        dispatch('requestOff');
        const payload = {resource: 'indicador', itemId: indicadorId}
        commit('deleteItem', payload, {root: true})
        const notification = {
          type: 'success',
          message: 'Indicador removido com sucesso'
        }
        return dispatch('notification/add', notification, {root: true})
      })
    },

    editarIndicador ({commit, dispatch}, payload) {
      dispatch('requestOn');
      return indicadorRequest.put(payload.id, payload.indicador).then(response => {
        dispatch('requestOff');
        const payload = {resource: 'indicador', item: response.data}
        commit('setItem', payload, {root: true})
        
        const notification = {
          type: 'success',
          message: 'Indicador atualizado com sucesso'
        }
        return dispatch('notification/add', notification, {root: true})
      })
    },

    editarIndicadorProgresso ({commit, dispatch}, payload) {
      dispatch('requestOn');
      return indicadorRequest.putProgresso(payload.id, payload.progresso).then(response => {
        dispatch('requestOff');
        const payload = {resource: 'indicador', item: response.data}
        commit('setItem', payload, {root: true})

        return response.data
      })
    },
    
    adicionarSubindicador({commit, dispatch}, payload) {
      dispatch('requestOn');
      return indicadorRequest.adicionarSubindicador(payload.logicaIntervencaoId, payload.indicadorPaiId, payload.indicadorFilhoId).then(response => {
        dispatch('requestOff');

        const payload = {resource: 'indicador', item: response.data}
        commit('setItem', payload, {root: true})

        const notification = {
          type: 'success',
          message: 'Subindicador adicionado com sucesso'
        }        
        dispatch('notification/add', notification, {root: true})
        
        return response.data
      }).catch(error => {
        const notification = {
          type: 'error',
          message: 'Ocorreu um erro inesperado. Por favor, tente novamente.'
        }        
        dispatch('notification/add', notification, {root: true})
        return error
      });
    },
    
    removerSubindicador({commit, dispatch}, payload) {
      dispatch('requestOn');
      return indicadorRequest.removerSubindicador(payload.logicaIntervencaoId, payload.indicadorPaiId, payload.indicadorFilhoId).then(response => {
        dispatch('requestOff');

        const payload = {resource: 'indicador', item: response.data}
        commit('setItem', payload, {root: true})

        const notification = {
          type: 'success',
          message: 'Subindicador removido com sucesso'
        }        
        dispatch('notification/add', notification, {root: true})
        
        return response.data
      }).catch(error => {
        const notification = {
          type: 'error',
          message: 'Ocorreu um erro inesperado. Por favor, tente novamente.'
        }        
        dispatch('notification/add', notification, {root: true})
        return error
      });
    },
  },

  getters: {
    all: (state) => {
      if (state.items) {
        return (Object.values(state.items)).sort((a,b) => (a.posicaoFormatada > b.posicaoFormatada) ? 1 : ((b.posicaoFormatada > a.posicaoFormatada) ? -1 : 0));
      }
      return []
    },
    byLogicaIntervencaoId: (state) => logicaIntervencaoId => {
      if (state.items) {
        return (Object.values(state.items).filter(indicador => indicador.logicaIntervencao.id === logicaIntervencaoId)).sort((a,b) => (a.posicao > b.posicao) ? 1 : ((b.posicao > a.posicao) ? -1 : 0));
      }
      return []
    },
    subindicadores: (state) => indicadorId => {
      if (state.items) {
        return (Object.values(state.items).filter(indicador => indicador.indicadorPaiId === indicadorId)).sort((a,b) => (a.posicao > b.posicao) ? 1 : ((b.posicao > a.posicao) ? -1 : 0));
      }
      return []
    },
    indicadorItensAutocomplete: (state) => projetoId => {
      if (state.items) {
        return (Object.values(state.items).filter(indicador => indicador.indicadorPaiId === null && indicador.logicaIntervencao.projeto.id === projetoId)).sort((a,b) => (a.posicao > b.posicao) ? 1 : ((b.posicao > a.posicao) ? -1 : 0));
      }
      return []
    },


    storage: (state) => indicadorId => {
      if (state.items) {
        return Object.values(state.items).filter(indicador => indicador.id === indicadorId)[0].itemStorage
      }
      return {}
    },
    byId: (state) => indicadorId => {
      if (state.items) {
        return Object.values(state.items)
            .find(indicador => indicador.id === indicadorId)
      }
      return {}
    },

  }

}







